export const CREATE_SEPARATE_TASK_USER_WISE = 'CREATE_SEPARATE_TASK_USER_WISE';
export const CREATE_SEPARATE_TASK_SITE_WISE = 'CREATE_SEPARATE_TASK_SITE_WISE';
